import React from 'react';
import { LANDING_PAGES, landingPageKey } from './landingRegistry';

/** Called once per bundle: lazy client components and eager prerender components share this tree. */
export function createLandingPages(components, entries = LANDING_PAGES) {
  return Object.freeze(Object.fromEntries(entries.map((entry) => {
    const Component = components[entry.component];
    function RegisteredLandingPage() { return <Component variant={entry.variant} landing={entry} />; }
    return [landingPageKey(entry), RegisteredLandingPage];
  })));
}
